<template>
    <div>
        <div v-if="invoice">
            <div>
                <h1 v-if="status === 'canceled'">
                    <span style="color: #EEB211">
                        <translate>Payment failed</translate>
                        &nbsp;
                        <i class="fa fa-frown-o font-symbol" aria-hidden="true"></i>
                    </span>
                </h1>
                
                <h1 v-if="status === 'paid'">
                    <span style="color: #28ac8a">
                        <translate>The invoice is paid.</translate>
                        <br>
                        <translate>Thank you!</translate>
                        &nbsp;
                        <i class="fa fa-smile-o font-symbol" aria-hidden="true"></i>
                    </span>
                </h1>
                
                <h1 v-if="status === 'expired'">
                    <span style="color: #EEB211">
                        <translate>Payment expired</translate>
                        &nbsp;
                        <i class="fa fa-frown-o font-symbol" aria-hidden="true"></i>
                    </span>
                </h1>
            </div>

            <div>
                <div>
                    <div class="box-title" v-translate>Invoice number</div>
                    <span class="box-content">{{ invoice.number }}</span>
                </div>
                <div>
                    <div class="box-title" v-translate>Total amount</div>
                    <span class="box-content">{{ invoice.total_amount }} {{ invoice.currency }}</span>
                </div>
            </div>

            <div>
                <span v-if="repayLink">
                    <translate>You can try again to pay this invoice by clicking</translate>
                    <a :href="repayLink"><translate> this link.</translate></a>
                </span>
            </div>

            <div class="pdf-preview-wrap" style="position: relative;">
                <iframe class="pdf-preview" v-if="invoice" :src="invoice.pdf_file"></iframe>
            </div>
        </div>

        <div v-if="!invoice && !loading">
            <div>
                <h1 v-translate>Oops this payment request does not seem to exist</h1>
                <div>
                    <div v-translate>Please contact the company that send you this link and report that you received this broken link.</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import MollieService from '@/store/services/idealpayment.service.js'
import VueDropzone from '@/components/VueDropzone'

export default {
    name: "MolliePaymentComplete",
    components: {VueDropzone},
    data() {
        return {
            invoice: null,
            status: null,
            repayLink: null,
            loading: true
        }
    },
    created() {
        let uuid = this.$route.params['uuid']
        
        MollieService.gekkoPaymentComplete(uuid).then((response) => {
            this.invoice = response.data.invoice
            this.status = response.data.status
            this.repayLink = response.data.repay_link
            this.loading = false
        }).catch(() => {this.loading = false})
    }
}
</script>

<style scoped>
.box-title {
    color: #888;
    font-size: 17px;
}

.box-content {
    font-weight: bold;
    font-size: 18px;
    white-space: nowrap;
}

.pdf-preview-wrap {
    padding: 0;
    aspect-ratio: 1/1.4142;
    max-width: 800px;
    margin: 0 auto;
}

.pdf-preview {
    height: 100%;
    width: 100%;
    border: 0;
    transition: opacity 0.3s ease;
}
</style>